import {createAction, props} from '@ngrx/store';
import {ProduktDTO} from '../../openapi/fakturierung-openapi';
import {DeepPartial} from '../../types/deep-partial';
import {MengeneinheitExtended} from '../../interfaces/mengeneinheit-extended.interface';


export class ProduktDialogActions {

  private static readonly prefix = '[Produkt Dialog] ';

  public static open = createAction(
    this.prefix + 'Open produkt dialog.',
    props<{
      produkt?: ProduktDTO,
      addToBeleg?: boolean,
    }>(),
  );

  public static changeEinheitenAutocomplete = createAction(
    this.prefix + 'Change einheiten autocomplete.',
    props<{ filter: string }>(),
  );

  public static changeProdukt = createAction(
    this.prefix + 'Change produkt.',
    props<{ produkt: DeepPartial<ProduktDTO> }>(),
  );

  public static close = createAction(
    this.prefix + 'Close produkt dialog.',
  );

  public static setMengeneinheiten = createAction(
    'Set mengeneinheiten',
    props<{
      mengeneinheiten: MengeneinheitExtended[];
    }>(),
  );

  public static assignNextProduktnummer = createAction(
    this.prefix + 'Assign next produktnummer.',
    props<{ nummer: number }>(),
  );
}
